module.exports = __webpack_public_path__ + "img/wushuizhan.4e7e5b9b.png";